import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "underline.svg",
  "use": "underline.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"underline.svg\"><path d=\"M8 4.5C8 4.22386 7.77614 4 7.5 4C7.22386 4 7 4.22386 7 4.5V12C7 14.7761 9.22386 17 12 17C14.7761 17 17 14.7761 17 12V4.5C17 4.22386 16.7761 4 16.5 4C16.2239 4 16 4.22386 16 4.5V12C16 14.2239 14.2239 16 12 16C9.77614 16 8 14.2239 8 12V4.5Z\" /><path d=\"M5.5 19C5.22386 19 5 19.2239 5 19.5C5 19.7761 5.22386 20 5.5 20H18.5C18.7761 20 19 19.7761 19 19.5C19 19.2239 18.7761 19 18.5 19H5.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol